// frontend/src/features/campaign/components/list/CampaignListView.js
import React from 'react';
import Banner from '../../../../ui/Banner';
import CampaignRoleBanner from '../common/CampaignRoleBanner';
import CampaignToolbar from './CampaignToolbar';
import CampaignCard from './CampaignCard';
import CampaignEmptyState from './CampaignEmptyState';
import { STATUS_OPTIONS } from '../../constants/campaignConstants';

export default function CampaignListView({
  userRoleLabel,
  roleAccessText,
  campaigns,
  filteredCampaigns,
  searchQuery,
  onSearchChange,
  selectedStatus,
  onSelectStatus,
  statusCounts,
  showBlueprints,
  onToggleBlueprints,
  onCloseBlueprints,
  onSelectPlaybook,
  onCreateCampaign,
  onSelectCampaign,
  onDeleteCampaign,
  onSeedSampleCampaigns,
  isSeeding = false,
}) {
  const hasActiveFilters = Boolean(searchQuery || selectedStatus !== 'ALL');

  return (
    <div className="campaign-container">
      {/* ── Page Header Banner ── */}
      <Banner
        title="Campaign Strategy Generator"
        subtitle="Plan, build, and orchestrate AI-powered B2B outbound sales campaigns."
        type="page-header"
      />

      {/* ── Slim Role Access Banner ── */}
      <CampaignRoleBanner userRoleLabel={userRoleLabel} roleAccessText={roleAccessText} />

      {/* ── Main Toolbar ── */}
      <CampaignToolbar
        searchQuery={searchQuery}
        onSearchChange={onSearchChange}
        showBlueprints={showBlueprints}
        onToggleBlueprints={onToggleBlueprints}
        onCloseBlueprints={onCloseBlueprints}
        onSelectPlaybook={onSelectPlaybook}
        onCreateCampaign={onCreateCampaign}
        selectedStatus={selectedStatus}
        onSelectStatus={onSelectStatus}
        statusCounts={statusCounts}
      />

      {/* ── Campaigns Results Summary Bar ── */}
      <div className="cmp-results-meta">
        <span className="cmp-results-count">
          Showing <strong>{filteredCampaigns.length}</strong> of <strong>{campaigns.length}</strong>{' '}
          campaigns
        </span>
        {selectedStatus !== 'ALL' && (
          <span className="cmp-active-filter-badge">
            Status: {STATUS_OPTIONS.find((s) => s.key === selectedStatus)?.label}
            <button onClick={() => onSelectStatus('ALL')}>
              <i className="fas fa-times" />
            </button>
          </span>
        )}
      </div>

      {/* ── Campaigns Cards Grid or Empty State ── */}
      {filteredCampaigns.length > 0 ? (
        <div className="cmp-cards-grid">
          {filteredCampaigns.map((camp) => (
            <CampaignCard
              key={camp.id}
              campaign={camp}
              onSelectCampaign={onSelectCampaign}
              onDeleteCampaign={onDeleteCampaign}
            />
          ))}
        </div>
      ) : (
        <CampaignEmptyState
          hasFilters={hasActiveFilters}
          onResetFilters={() => {
            onSearchChange('');
            onSelectStatus('ALL');
          }}
          onCreateCampaign={onCreateCampaign}
          onSeedSampleCampaigns={onSeedSampleCampaigns}
          isSeeding={isSeeding}
        />
      )}
    </div>
  );
}
